import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Text from 'components/Text';

import './checkbox.styles.scss';
/**
 * Styled checkbox with WCAG enabled.
 * @example ../../examples/FormCheckbox.md
 */
export default class FormCheckbox extends Component {
    render() {
        const { id, name, label, checked, onChange, defaultChecked, className } = this.props;
        return (
            <div className={'checkbox ' + (className ? className : '')}>
                <input
                    id={id}
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    defaultChecked={defaultChecked}
                />
                <label htmlFor={id}>
                    <span className="label-text"><Text textKey={label} /></span>
                </label>
            </div>
        );
    }
}

FormCheckbox.propTypes = {
    /** Checkbox ID. Must be unique and is required for all instances. */
    id: PropTypes.string.isRequired,
    /** Component name */
    name: PropTypes.string.isRequired,
    /** Text label for checkbox. Also used to describe the checkbox to screen readers. */
    label: PropTypes.string.isRequired,
    /** Default state of checkbox */
    checked: PropTypes.bool,
    /** Callback function triggered on change event. */
    onChange: PropTypes.func.isRequired,
    defaultChecked: PropTypes.bool,
    className: PropTypes.string,
};
